module.exports = __webpack_public_path__ + "static/media/team-tania.33019c8d.jpg";